import React from "react";
import { Box, Typography } from "@mui/joy";
import { Question } from "pages/onboarding/part/convention/Convention_2_QnA";
import { theme } from "styles/theme";
import versus from "static/image/onboarding/versus.svg";
import CustomTypography from "./CustomTypography";

export type SelfCheckQuestionProps = {
  main: string;
  left: string;
  right: string;
}

export function SelfCheckQuestion({ question }: { question: SelfCheckQuestionProps }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <CustomTypography
        variant="H3"
        sx={{
          color: theme.vars.palette.Content.Strong,
          fontWeight: 500,
          mb: "24px",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        {question.main}
      </CustomTypography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          gap: 1, // 요소 간 간격
        }}
      >
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography
            variant="Subtitle"
            sx={{
              color: theme.vars.palette.Content.Strong,
              fontWeight: 700,
              // [수정] 'pre' -> 'pre-wrap'으로 변경하여 자동 줄바꿈 허용
              whiteSpace: "pre-wrap",
              // [추가] 한글 단어가 중간에 잘리는 현상 방지
              wordBreak: "keep-all",
            }}
          >
            {question.left}
          </Typography>
        </Box>

        {/* 가운데(versus) 이미지 */}
        <Box>
          <img
            src={versus}
            alt="onboarding"
            style={{
              flexShrink: 0, // 이미지가 줄어들지 않도록 설정
            }}
          />
        </Box>

        {/* 오른쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography
            variant="Subtitle"
            sx={{
              fontWeight: 700,
              color: theme.vars.palette.Content.Strong,
              // [수정] 'pre' -> 'pre-wrap'으로 변경하여 자동 줄바꿈 허용
              whiteSpace: "pre-wrap",
              // [추가] 한글 단어가 중간에 잘리는 현상 방지
              wordBreak: "keep-all",
            }}
          >
            {question.right}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}